import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAddonsLoading = (isLoading) => ({
  type: actionTypes.SET_ADDONS_LOADING,
  payload: isLoading
})